export const defaultColDef = {
    cellStyle: (params: any) => {
        return {
            paddingLeft: params.data.indentLevel * 8 + "px",
        };
    },
    flex: 1,
    minWidth: 140,
    cellClass: "cursor-pointer hover:bg-selected transition-colors",
};
